import React, { useEffect, useState } from 'react'
import { Layout, Space, Divider, Empty, Spin } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import LessonCard from './lessonCard'
import { useDispatch, useSelector } from 'react-redux'
import { IState } from '../../reducers'

import API from '../../api'
import { Lesson } from '../../api/course'
import SearchBar from 'components/SearchBar'
import SideBar from './sidebar'
import { SetCurrentGrade, UpdateSemester } from 'reducers/course'
import OutlineCom from './outline'
import { newOrgType, Module, Grade } from 'api/org'
import LoadingCom from 'components/Loading'
import { COURSE_TYPE_PRIVATE, COURSE_TYPE_PUBLIC } from 'api/constants'
import { BookOutlined } from '@ant-design/icons'
import { getLessonCount } from 'api/utils'

const { Sider, Content } = Layout
const Grades = () => {
  const [module, setModule] = useState<Module>(newOrgType())
  const [courseView, setCourseView] = useState('card')
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const [total, setTotal] = useState(0)
  const user = useSelector((state: IState) => state.user)
  const dispatch = useDispatch()

  const [semesterLesson, setSemesterLessons] = useState<Lesson[][]>([])

  let modules = useSelector((state: IState) => state.org.modules)
  const semester = useSelector((state: IState) => state.course.semester!)
  const currentGrade = useSelector((state: IState) => state.course.currentGrade)

  if (user.type === "guest" || user.type === "student") {
    if (modules.length > 7) {
      modules = modules.slice(0, 7)
    }
  }

  // 获取课程列表
  const UpdateCourseList = () => {
    setLoading(true)
    let type = COURSE_TYPE_PRIVATE
    if (user.type === 'guest' || user.type === 'student') {
      type = COURSE_TYPE_PUBLIC
    }

    const ids = currentGrade!.lesson_groups![semester]
    console.log('currentGrade', currentGrade);

    console.log('ids ', ids)

    if (ids) {
      API.listCourse(ids, type).then(res => {
        console.log(res.data.items)

        let items = res.data.items
        for (let i = 0; i < items.length; i++) {
          const it = items[i]
          let total = 0
          it.map(l => {
            let c = getLessonCount(l.duration)
            total = total + c
            if (c > 1) {
              l.renderSort = `${total - c + 1}-${total}`
            } else {
              l.renderSort = `${total}`
            }
          })

          if (i === 0) {
            // 设置总数
            setTotal(total)
          }
        }

        setSemesterLessons(res.data.items)
      })
    } else {
      setTotal(0)
      setSemesterLessons([])
    }

    setLoading(false)
  }

  const chooseModule = ({ key }) => {
    modules.forEach(m => {
      m.grades.forEach(grade => {
        if (parseInt(key) === grade.id) {
          setModule(m)
        }
      })
    })
  }

  const setGrade = (g: Grade) => {
    console.log('set Grade', g)
    setCourseView('card')
    dispatch(SetCurrentGrade(g))
    dispatch(UpdateSemester(1))
    history.push('/grades/' + g.id)

  }

  useEffect(() => {
    if (modules.length !== 0) {
      chooseModule({ key: id })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modules.length])

  // 根据学期更新课程列表
  useEffect(() => {
    if (user.user_id !== '' && currentGrade) {
      // 查看state
      UpdateCourseList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semester, currentGrade, user.user_id])

  {/* 如果只有一个学期，就不显示 */ }
  const semtip1 = !currentGrade?.lesson_groups?.[0];
  const semtip2 = !currentGrade?.lesson_groups?.[2];
  const semtip = semtip1 && semtip2;
  // console.log('semtip', semtip, "semtip1", semtip1, "semtip2", semtip2);
  {/* 学期导航的全部显示 */ }
  let semesters = (
    //学期导航
    <div className={`semester-group`}>
      {/* 前置课程 */}
      <div className={`front-course-group ${currentGrade?.lesson_groups?.[0] ? '' : 'hide'}`}>
        <div
          className={`semester-common ${semester === 0 ? 'semester-active' : ''
            }`}
          onClick={() => dispatch(UpdateSemester(0))}
        >
          <BookOutlined className="front-course-icon" />
          前置课程
        </div>
        <Divider
          type="vertical"
          style={{ backgroundColor: '#BFBFBF', width: 2, top: 5 }}
          className="semester-divider"
        />
      </div>
      {/* 上学期 */}
      <div className='front-course-group'>
        <div
          className={`semester-common ${semester === 1 ? 'semester-active' : ''
            } ${currentGrade?.lesson_groups?.[1] ? '' : 'hide'}`}
          onClick={() => dispatch(UpdateSemester(1))}
        >
          上学期
        </div>
        <Divider
          type="vertical"
          style={{ backgroundColor: '#BFBFBF', width: 2, top: 5 }}
          className="semester-divider"
        />
      </div>
      {/*  下学期  */}
      <div
        className={`semester-common ${semester === 2 ? 'semester-active' : ''
          } ${currentGrade?.lesson_groups?.[2] ? '' : 'hide'}`}
        onClick={() => dispatch(UpdateSemester(2))}
      >
        下学期
      </div>
      {/*  拓展课程  */}
      <div className={`front-course-group ${currentGrade?.lesson_groups?.[3] ? '' : 'hide'}`}>
        <Divider
          type="vertical"
          style={{ backgroundColor: '#BFBFBF', width: 2, top: 5 }}
          className="semester-divider"
        />
        <div
          className={`semester-common ${semester === 3 ? 'semester-active' : ''
            }`}
          onClick={() => dispatch(UpdateSemester(3))}
        >
          拓展课程
        </div>
      </div>
    </div>
  )


  return (
    <>
      <div style={{ overflow: 'auto', height: '100%' }}>
        <div
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/course-banner.png)` }}
          className="course-center-banner-outer"
        >
          <SearchBar module="Course Center" />
        </div>

        <div className="layout-content-mask">
          <div className="layout-content-bg-LB"></div>
          <div className="layout-content-bg-RT"></div>
          <Layout className="course-layout">
            <Sider className="course-sider">
              <SideBar
                id={id}
                module={module}
                courseView={courseView}
                setGrade={setGrade}
                modules={modules}
                setModule={setModule}
                setCoursetView={setCourseView}
              />
            </Sider>
            {
              <Spin spinning={loading} indicator={<LoadingCom />}>

                <Content className="course-content" style={{ width: 'auto' }}>
                  {courseView === 'outline' ? (
                    <OutlineCom orgType={module} />
                  ) : (
                    // 课程中心右侧主体内容
                    <div className="course-group">
                      <div className="course-group-header">
                        {/* 学期显示 */}
                        {/* 有的分类>小学低年级,有的没有>初中 */}
                        {semtip ? <div></div> : semesters}
                        <div style={{ color: '#8C8C8C' }}>{`共 ${total} 课时`}</div>
                      </div>
                      <div>
                        {semesterLesson.map((cg, index) => (
                          <div key={index + 'cg'}>
                            {/* 判断方案要不要显示，有就显示,没有就不显示 */}
                            <div
                              className={`title course-category ${semesterLesson.length > 1 ? '' : 'hide'
                                }`}
                            >
                              方案 {index + 1}
                            </div>
                            {cg.length === 0 ? (
                              <div className="course-wall-outer">
                                <Empty
                                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  description={<span>当前无课程</span>}
                                ></Empty>
                              </div>
                            ) : (
                              <Space
                                wrap
                                size={[24, 24]}
                                className="course-wall"
                                style={{ marginBottom: 0 }}
                              >
                                {cg.map(lesson => (
                                  <LessonCard
                                    key={lesson.id + 'lesson'}
                                    lesson={lesson}
                                    total={total}
                                    grade_id={parseInt(id)}
                                  />
                                ))}
                              </Space>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </Content>
              </Spin>
            }
          </Layout>
        </div>
      </div>
    </>
  )
}

export default Grades
